import React from 'react'
import PropTypes from 'prop-types'
import { Loader } from '@adc/ui-adc'
import classNames from 'classnames/bind'
import styles from './styles.scss'
const cx = classNames.bind(styles)

const ProcessingMessageWrapper = ({ message, elmId }) => (
  <div className={cx('processing-message-container')}>
    <Loader active inverted>
      <h3
        className={cx('processing-message-container-message')}
        data-elm-id={elmId}
      >
        {message}
      </h3>
    </Loader>
  </div>
)

ProcessingMessageWrapper.propTypes = {
  message: PropTypes.string,
  elmId: PropTypes.string,
}

export default ProcessingMessageWrapper
